// Este archivo se genera automáticamente

import terms_es from './terms_es';
import terms_en from './terms_en';
import terms_de from './terms_de';
import terms_fr from './terms_fr';
import terms_it from './terms_it';
import terms_nl from './terms_nl';
import terms_cz from './terms_cz';
import terms_sk from './terms_sk';
import terms_ru from './terms_ru';
import terms_iw from './terms_iw';
import terms_tr from './terms_tr';
import terms_pt from './terms_pt';

export const termsByLang = {
    es: terms_es,
    en: terms_en,
    de: terms_de,
    fr: terms_fr,
    it: terms_it,
    nl: terms_nl,
    cz: terms_cz,
    sk: terms_sk,
    ru: terms_ru,
    iw: terms_iw,
    tr: terms_tr,
    pt: terms_pt,
};
